type Either<T> =
	| Promise<{ error: Error; result: undefined }>
	| Promise<{ error: undefined; result: T }>;

/**
 * This function is used to wrap a promise that might fail.
 * Helps with error handling, considering some nextjs function throw errors to function properly,
 * it is better for us to use this function instead of wrapping big logical blocks in try/catch.
 */
export const mightFail = async <T>(promise: Promise<T>): Promise<Either<T>> => {
	try {
		const result = await promise;
		return { error: undefined, result };
	} catch (error) {
		if (error instanceof Error) {
			return { error, result: undefined };
		}
		return { error: new Error("Unknown error"), result: undefined };
	}
};
